const getConfig = () => {
    const env = window.__ENV || {};
    const project = env.REACT_APP_PROJECT || 'zippyy';
    const appEnv = env.REACT_APP_ENV || 'development';
    return {
        project,
        env: appEnv,
        projectName: env.REACT_APP_PROJECT_NAME || 'Zippyy',
        api: {
            baseUrl: env.REACT_APP_API_BASE_URL || '',
            onboardingUrl: env.REACT_APP_API_BASE_URL_ONBOARDING || '',
            storeUrl: env.REACT_APP_API_BASE_URL_STORE || '',
            storeUrlShopify: env.REACT_APP_API_STORE_URL || '',
        },
        cognito: {
            clientId: env.REACT_APP_CLIENT_ID || '',
            userPoolId: env.REACT_APP_USER_POOL_ID || '',
        },
        google: {
            clientId: env.REACT_APP_GOOGLE_CLIENT_ID || '',
            password: env.REACT_APP_GOOGLE_PASSWORD || '',
        },
        maps: {
            appId: env.REACT_APP_MAP_APP_ID,
            appCode: env.REACT_APP_MAP_APP_CODE || '',
            apiKey: env.REACT_APP_MAP_KEY || '',
        },
        captcha: {
            key: env.REACT_APP_CAPTCHA_KEY || '',
        },
        razorpay: {
            keyId: env.RAZORPAY_KEY_ID || '',
        },
        analytics: {
            clarityProjectId: env.CLARITY_PROJECT_ID || '',
            googleApiKey: env.GOOGLE_API_KEY || '',
        },
        payment: {
            secretDev: env.REACT_APP_PAYMENT_SECRET_DEV || '',
            secretProd: env.REACT_APP_PAYMENT_SECRET_PROD || '',
        },
        theme: {
            primaryColor: env.REACT_APP_PRIMARY_COLOR || '#D54029',
            secondaryColor: env.REACT_APP_SECONDARY_COLOR || '#2EC4B6',
            backgroundColor: env.REACT_APP_BACKGROUND_COLOR || '#1A1A2E',
            surfaceColor: env.REACT_APP_SURFACE_COLOR || '#16213E',
            textPrimaryColor: env.REACT_APP_TEXT_PRIMARY_COLOR || '#FFFFFF',
            textSecondaryColor: env.REACT_APP_TEXT_SECONDARY_COLOR || '#E2E8F0',
            accentColor: env.REACT_APP_ACCENT_COLOR || '#FF8555',
            loginTheme: env.REACT_APP_LOGIN_THEME || 'modern-dark',
            logo: env.REACT_APP_LOGO_PATH || '/logos/zippyy.svg',
            favicon: env.REACT_APP_FAVICON_PATH || '/favicons/zippyy.ico',
        },
        company: {
            email: env.REACT_APP_COMPANY_EMAIL || 'support@zippyy.com',
            supportPhone: env.REACT_APP_SUPPORT_PHONE,
        },
        features: {
            rememberMe: env.REACT_APP_FEATURE_REMEMBER_ME !== 'false',
            socialLogin: env.REACT_APP_FEATURE_SOCIAL_LOGIN === 'true',
            twoFactorAuth: env.REACT_APP_FEATURE_TWO_FACTOR_AUTH === 'true',
        },
    };
};
export const config = getConfig();
export const isProduction = () => config.env === 'production';
export const isDevelopment = () => config.env === 'development';
export const isProject = (project) => config.project === project;
export const getApiUrl = (type = 'base') => {
    switch (type) {
        case 'onboarding':
            return config.api.onboardingUrl;
        case 'store':
            return config.api.storeUrl;
        default:
            return config.api.baseUrl;
    }
};
